<template>
  <div ref="areaJanela" class="modal fade" :class="{'show': showModal}" tabindex="-1" :style="{'display': (showModal ? 'block' : 'none')}" role="dialog" aria-labelledby="compose" :aria-hidden="!showModal">
    <!--begin::Modal dialog-->
    <transition enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut" mode="out-in" @after-leave="onAfterLeave" @after-enter="onAfterEnter">
      <div 
        class="modal-dialog modal-dialog-centered" 
        :class="{'modal-fullscreen': fullscreen, 'mw-650px': (!fullscreen) && (!maxwidth)}" 
        style="z-index: 1051;" v-show="showModalInside" 
        :style="{'max-width': maxwidth ? maxwidth + ' !important' : '', 'max-height': maxheight ? maxheight + ' !important' : ''}"
      >
        <!--begin::Modal content-->
        <div class="modal-content" ref="conteudo" :class="{'janela-ajustada': dimensoes}" :style="estiloJanela">
          <!--begin::Modal header-->
          <div class="modal-header pb-0 border-0" :class="{'cabecalho-movel': permiteMover}"
               @pointerdown="iniciarArrasto" @pointermove="moverJanela" @lostpointercapture="finalizarAjuste">
            <h5 v-if="title || permiteMover">
              <i v-if="permiteMover" aria-hidden="true" class="las la-arrows-alt me-1"></i>{{ title }}<slot name="aposTitulo"></slot>
            </h5>
            <button v-if="chaveArmazenamento" type="button" class="btn btn-sm btn-icon btn-active-color-primary ms-auto"
                    :title="$t('Restaurar tamanho e posição da janela')" :aria-label="$t('Restaurar tamanho e posição da janela')"
                    @click="restaurarPadraoJanela">
              <i class="las la-undo" aria-hidden="true"></i>
            </button>
            <!--begin::Close-->
            <slot name="acoesCabecalho"></slot>
            <button v-if="!hideClose && (title || rotuloFechar)" type="button" class="btn btn-sm btn-light" :class="{'ms-auto': !chaveArmazenamento, 'btn-fechar-modal': permiteMover && (!rotuloFechar || rotuloFechar === $t('Fechar')), 'btn-cancelar-suave': rotuloFechar === $t('Cancelar')}" @click="fecharModalInterno">
              {{ rotuloFechar || $t('Fechar') }}
              <i v-if="rotuloFechar === $t('Cancelar')" class="las la-times ms-1 pe-0" aria-hidden="true" style="font-size:14px;"></i>
            </button>
            <div v-else-if="!hideClose" class="btn btn-sm btn-icon btn-active-color-primary" @click="fecharModalInterno">
              <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
              <span class="svg-icon svg-icon-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                </svg>
              </span>
              <!--end::Svg Icon-->
            </div>
            <!--end::Close-->
          </div>
          <!--begin::Modal header-->
          <!--begin::Modal body-->
          <div 
            class="modal-body mx-5 mx-xl-18 pt-0 pb-15" 
            style="padding-bottom: 22.75px !important; margin: 0 !important;" 
            :style="{'overflow': nooverflow ? 'hidden' : ''}"
          >
            <slot></slot>
          </div>
          <!--end::Modal body-->
          <slot name="rodape"></slot>
          <span v-if="permiteRedimensionar" class="alca-tamanho" aria-hidden="true"
                @pointerdown="iniciarRedimensionamento" @pointermove="redimensionar"
                @lostpointercapture="finalizarAjuste"></span>
        </div>
        <!--end::Modal content-->
      </div>
    </transition>
    <!--end::Modal dialog-->
    <div v-if="showModal" class="modal-backdrop fade show" @click="fecharModalInterno"></div>
  </div>
</template>

<script>
import janelaAjustavel from './janelaAjustavel';

export default {
  name: "ModalBase",
  mixins: [janelaAjustavel],
  data() {
    return {
      showModal: false, 
      showModalInside: false,
    };
  }, 
  props: ["fullscreen", "maxwidth", "maxheight", "nooverflow", "title", "hideClose", "rotuloFechar", "preventClose", "movel", "redimensionavel", "chavePreferenciaJanela", "idJanela"],
  computed: {
    janelaVisivel() { return this.showModalInside; }
  },
  methods: {
    toggleModal() {
      if (this.permiteMover || this.permiteRedimensionar) {
        this.centralizarJanela();
        if (!this.showModal) {
          window.addEventListener('resize', this.restaurarJanela);
        } else {
          window.removeEventListener('resize', this.restaurarJanela);
        }
      }
      this.showModal = !this.showModal;
      this.showModalInside = !this.showModalInside;
      if (this.showModalInside && this.chaveArmazenamento) this.$nextTick(this.restaurarJanela);
      this.$emit("toggleModal", this.showModal);
    },
    onAfterLeave() {
      window.removeEventListener('resize', this.restaurarJanela);
      this.showModal = false;
      this.$emit("toggleModal", this.showModal);
    }, 
    onAfterEnter() {
      this.showModal = true;
      this.$emit("afterToggleEnter", this.showModal);
    }, 
    fecharModalInterno() {
      if (this.preventClose) { this.$emit("solicitarFechamento"); return; }
      this.showModalInside = false;
    }
  }
}  
</script>

<style scoped src="./janelaAjustavel.css"></style>
<style scoped>
.janela-ajustada {position:absolute;}
.janela-ajustada > .modal-body {min-height:0;overflow:auto;}
</style>
